<template xmlns:v-images-loaded="http://www.w3.org/1999/xhtml">
    <div v-images-loaded:on.progress="imageProgress">
        <div v-masonry gutter="15" transition-duration="0s" item-selector=".item">
            <div v-bind:key="index" v-masonry-tile class="item" v-for="(photo, index) in filterPhotos">
                <card class="border-0 mb-3" no-body shadow style="width: 21.5rem">

                    <img alt="flickr image" class="img-fluid"
                         :src="photo[1].url">
                    <div class="px-3 mt-3 pb-3">
                        <badge type="primary mb-3" rounded>{{photo[1].date | formatDate}}</badge>
                        <badge type="orange mb-3" rounded>{{photo[1].owner_name}}</badge>

                        <h6 class="text-primary text-uppercase">{{photo[1].title}}</h6>
                        <p class="description mt-3">{{photo[1].description | shorten}}</p>

                        <div class="d-block">
                            <badge type="thingiverse" rounded>{{photo[1].count_comments}}
                                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'comments' }"/>
                            </badge>
                            <badge type="thingiverse" rounded>{{photo[1].count_faves}}
                                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'star' }"/>
                            </badge>
                        </div>
                        <div class="d-block mt-2">
                            <badge :key="index" v-for="(tag, index) in splitTags(photo[1].tags)" type="primary" rounded>
                                {{tag | shortenTag}}
                            </badge>
                        </div>
                        <base-button tag="a" :href="getOwnerPageUrl(photo[1].owner_id)" target="_blank" type="primary"
                                     class="mt-4 shadow text-white">
                            Creator's Page
                        </base-button>
                    </div>

                </card>
            </div>
        </div>
        <div class="d-flex justify-content-center" v-if="maxIndex < 100">
            <base-button tag="a"
                         class="mb-3 w-25 mb-sm-0 bg-ptwist text-white"
                         type="button"
                         @click="loadMore">
                Load more
            </base-button>
        </div>
    </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'
import moment from 'moment'

export default {
  name: 'repositories-masonry',
  directives: {
    imagesLoaded
  },
  data () {
    return {
      maxIndex: 12
    }
  },
  computed: {
    filterPhotos () {
      return this.photos.filter((photo, index) => index < this.maxIndex)
    }
  },
  methods: {

    splitTags (tags) {
      return tags.split(' ')
    },
    imageProgress (instance, image) {
      return image.isLoaded ? 'loaded' : 'broken'
    },
    loadMore () {
      if (this.maxIndex < 100) {
        this.maxIndex += 9
      }
    },
    getOwnerPageUrl (ownerId) {
      return 'https://www.flickr.com/photos/' + ownerId
    }
  },
  filters: {
    shorten (description) {
      description = description.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '')
      let div = document.createElement('div')
      div.innerHTML = description
      description = div.textContent || div.innerText || ''
      return description.substring(0, 250)
    },
    formatDate (date) {
      return moment(date).format('D-MMM-YY')
    },
    shortenTag (tag) {
      return tag.substring(0, 30)
    }
  },
  props: ['photos']
}
</script>
<style>
</style>
